<p *ngIf="this.label" [class.d-inline-flex]="this.direction == 'row'">{{this.label | translate}}</p>
<mat-radio-group
  [class.direction-row]="this.direction === 'row'"
  class="innporting-radio-group"
  [(ngModel)]="choosenOption" (change)="onChooseOption()">
  <mat-radio-button *ngFor="let item of items;"
                    color="primary"
                    class="innporting-radio-group-button"
                    [value]="item.value">
    {{item.keyToShowValue | translate}}
  </mat-radio-button>
</mat-radio-group>
